import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import {AppModule} from "../app.module";
import {CurrentUserIsNotLoggedIn, UserService} from "../services/user.service";
import {filter, firstValueFrom} from "rxjs";
import {HubUser} from "../apis/backend";

@Injectable()
export class AuthGuard  {

    constructor(private router: Router, private userService: UserService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        
        return firstValueFrom(this.userService.CurrentUser.pipe(filter(x => x != null))).then((user: HubUser) => {
            if (user == CurrentUserIsNotLoggedIn) {
                this.router.navigate(['/login'], { queryParams: { returnUrl: state.url }});
                return false;
            }
            return true;
        });
    }
}